import { jwtDecode } from 'jwt-decode';

const expireToken = (token: string) => {
  if (!token) return false;

  try {
    const decodedToken = jwtDecode(token);

    if (decodedToken !== undefined && decodedToken.exp) {
      return decodedToken.exp < Date.now() / 1000;
    }

    return false;
  } catch {
    return true;
  }
};

export default expireToken;
